module.exports = __webpack_public_path__ + "img/98060fdbc81c5a7f4a77257f57406a5a.246ff39b.png";